import {Component} from '@angular/core';
/**
 * \@title Basic select
 */
export class SelectOverviewExample {
  foods = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'select-overview-example',
  templateUrl: 'select-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SelectOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
SelectOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SelectOverviewExample.ctorParameters;
/** @type {?} */
SelectOverviewExample.prototype.foods;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
